export class QuoteResult {
    constructor(single = "", guaranteedDeath = "", chronicIllness = "", terminalIllness = "") {
        this.single = single;
        this.guaranteedDeath = guaranteedDeath;
        this.chronicIllness = chronicIllness;
        this.terminalIllness = terminalIllness;
    }
}
